import React from "react";
import { createRoot } from "react-dom/client";

import { datadogRum } from "@datadog/browser-rum";
import { reactPlugin } from "@datadog/browser-rum-react";

import environment from "@environment/variables";

import { initializeFeatureFlags } from "@utils/featureFlags";
import { initChameleon } from "@utils/chameleon/chameleon";

import { configureAmplify } from "./amplify";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

import "react-toastify/dist/ReactToastify.css";

import "./index.css";

const APP_NAME = "ct-agent-service";

datadogRum.init({
  applicationId: environment.datadog.applicationId,
  clientToken: environment.datadog.clientToken,
  defaultPrivacyLevel: "allow",
  service: "agent-portal",
  site: "datadoghq.com",
  // TODO: Change Sampling based on ENV
  sessionSampleRate: environment.name !== "serv" ? 100 : 0,
  sessionReplaySampleRate: environment.name !== "serv" ? 100 : 0,
  env: environment.name,
  plugins: [reactPlugin({ router: true })],
});

configureAmplify();

initializeFeatureFlags(APP_NAME);
initChameleon();

const container = document.getElementById("app");
const root = createRoot(container);
root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
